/** [companyNo] 在 [states] props 中的 index */
export const index = {
  companyNo: 0,
};
